import React from 'react';
import {WorkflowItem} from '../types';
import {Link} from 'react-router-dom';

type WorkflowListItemProps = {
    workflowItem: WorkflowItem,
    isPinned: boolean,
    pin: (shouldPin: boolean) => void,
};

export const WorkflowListItem: React.FunctionComponent<WorkflowListItemProps> = ({
                                                                                     workflowItem,
                                                                                     isPinned,
                                                                                     pin
                                                                                 }) => {
    return (
        <div key={workflowItem.id} className="col-12 col-sm-6 col-lg-3 p-2">
            <div className="card p-0 shadow-sm h-100 workflow-item">
                <div className="card-body" style={{height: '100%'}}>
                    <Link to={`/new/${workflowItem.id}`} style={{display: 'block', height: '100%'}}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%'
                        }}>
                            <p className="p-0 m-0">{workflowItem.name}</p>
                            <small className="text-muted" style={{flexGrow: 1}}>{workflowItem?.description || ''}</small>

                            {workflowItem?.businessOwners?.length > 0 &&
                            <small className="d-block mt-2">
                                Questions? {workflowItem?.businessOwners?.map((owner: string, index: number) => (
                                <>
                                    {index > 0 && ', '}
                                    <a href={`mailto:${owner}`}
                                       style={{color: '#0056b3'}}
                                       onClick={(e) => e.stopPropagation()}
                                    >{owner}</a>
                                </>
                            ))}
                            </small>
                            }

                        </div>
                    </Link>
                </div>
                <div className="card-footer d-flex">
                    <a href="#"
                       className="mr-auto pl-0"
                       onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();

                           pin(!isPinned);
                       }}
                    >
                        <i className={(isPinned ? 'pinned' : '') + ' fas fa-thumbtack pin-workflow'}/>
                    </a>

                    {workflowItem.isAdmin &&
                    <Link to={`/admin/assignee-maintenance/${workflowItem.id}`}>
                        <i className="fas fa-user-cog"/>
                    </Link>
                    }
                    {workflowItem.dataform &&
                    <Link to={`/dataform/${workflowItem.dataform.workflow_id}/${workflowItem.dataform.id}`}>
                        <i className="fas fa-th-list"/>
                    </Link>
                    }
                    {workflowItem.userCanViewGraphs &&
                    <Link to={`/dashboard/${workflowItem.id}`}>
                        <i className="fas fa-chart-area"/>
                    </Link>
                    }
                    <Link to={`/list/${workflowItem.id}`}>
                        <i className="fas fa-table"/>
                    </Link>
                    <Link to={`/workflow/${workflowItem.id}`}>
                        <i className="fas fa-home"/>
                    </Link>
                </div>
            </div>
        </div>
    )
};